import React, { useEffect, useState } from "react";
import SkeletonTable from "../../../components/table/SkeletonTable.jsx";
import columns from "../../../columns/reviewDoc/viewReviewDoc.js";
import { Button, Form, Select, Spin } from "antd";
import ModalComponent from "../../../components/modals/ModalComponent.jsx";
import ConfirmationModal from "../../../components/modals/ConfirmationModal";
import LoadableButton from "../../../components/buttons/LoadableButton.jsx";
import {
  GetOrganizerAnswerApi,
  ReviewAnswerApi,
  GetInvoiceListApi,
  SendInvoiceApi,
  UnsubmitOrganizerApi,
} from "../../../api/request/taskManager/taskManager.js";
import { useNavigate, useParams } from "react-router-dom";
import { LoadingOutlined } from "@ant-design/icons";
import toast from "react-hot-toast";
import PdfLink from "../../../components/common/PdfLink.jsx";
import AnswerModal from "./AnswerModal.jsx";
import Edit from "../../../assets/Edit.jsx";
import ViewFilesModal from "./ViewFilesModal.jsx";
import { getSocket } from "../../../services/Socket.js";

export default function ViewReviewDoc() {
  const { id } = useParams();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingInvoice, setIsLoadingInvoice] = useState(false);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [initialValues, setInitialValues] = useState({ invoice_temp_id: null });
  const [data, setData] = useState([]);
  const [clientData, setClientData] = useState({});
  const [invoiceOptions, setInvoiceOptions] = useState([]);
  const [isUnsubmitLoading, setIsUnsubmitLoading] = useState(false);
  const [isUnsubmitOpen, setIsUnsubmitOpen] = useState(false);
  const socket = getSocket();
  const [selectedQuestion, setSelectedQuestion] = useState({});
  const [isAnswerOpen, setIsAnswerOpen] = useState(false);
  const [isFilesOpen, setIsFilesOpen] = useState(false);

  const getQuestions = async () => {
    try {
      setIsLoading(true);
      let params = { organizer_id: id };
      const { data } = await GetOrganizerAnswerApi(params);
      if (data?.status) {
        setClientData(data?.client_selected_org);
        setData(
          data?.data?.map((section) => {
            return {
              ...section,
              questions: section?.questions?.map((question) => {
                return {
                  ...question,
                  response_text: (
                    <div className="flex items-center gap-3 max-w-[250px]">
                      {question?.response_text && (
                        <p className="text-wrap">{question?.response_text}</p>
                      )}
                      <div
                        className="cursor-pointer"
                        onClick={() => {
                          setSelectedQuestion(question);
                          setIsAnswerOpen(true);
                        }}
                      >
                        <Edit />
                      </div>
                    </div>
                  ),
                  ...(question?.documents?.length && {
                    response_text: (
                      <a
                        onClick={() => {
                          setSelectedQuestion(question);
                          setIsFilesOpen(true);
                        }}
                        className="hover:text-primary text-primary underline underline-offset-4"
                        target="_blank"
                      >
                        View Files🔻
                      </a>
                    ),
                  }),
                  question: (
                    <div
                      className={`${
                        !question?.reviewed_checked
                          ? "font-semibold highlight-text"
                          : ""
                      }`}
                    >
                      {question?.field_label || "--"}
                    </div>
                  ),
                  review: (
                    <div
                      className="cursor-pointer"
                      onClick={() =>
                        reviewHandler(
                          section?.id,
                          question?.id,
                          question?.reviewed_checked
                        )
                      }
                    >
                      <img
                        className="size-7"
                        src={
                          question?.reviewed_checked
                            ? "/assets/icons/outlined-check-circle.svg"
                            : "/assets/icons/outlined-circle.svg"
                        }
                      />
                    </div>
                  ),
                };
              }),
            };
          })
        );
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getQuestions();
  }, []);

  const sendInvoiceHandler = async (values) => {
    try {
      setIsLoadingSubmit(true);
      let params = { organizer_id: id, ...values };
      const { data } = await SendInvoiceApi(params);
      if (data?.status) {
        toast.success(data?.message);

        socket.emit(
          "updateTask",
          JSON.stringify({ task: 1, userId: clientData?.id })
        );
        navigate("/verify_doc");
      }
      form.resetFields();
      setIsModalOpen(false);
      setIsLoadingSubmit(false);
    } catch (error) {
      toast.error(error?.response?.data?.message);
      setIsLoadingSubmit(false);
    }
  };

  const spinner = (
    <div className="my-[3px]">
      <Spin indicator={<LoadingOutlined />} />
    </div>
  );

  const setReviewData = (sectionId, questionId, status, isLoading) => {
    setData((prev) => {
      return prev.map((section) => {
        if (section.id === sectionId) {
          return {
            ...section,
            questions: section?.questions?.map((question) => {
              if (question.id === questionId) {
                return {
                  ...question,
                  reviewed_checked: status,
                  question: (
                    <div
                      className={`${
                        !status ? "font-semibold highlight-text" : ""
                      }`}
                    >
                      {question?.field_label || "--"}
                    </div>
                  ),
                  review: isLoading ? (
                    spinner
                  ) : (
                    <div
                      className="cursor-pointer"
                      onClick={() =>
                        reviewHandler(sectionId, questionId, status)
                      }
                    >
                      <img
                        className="size-7"
                        src={
                          status
                            ? "/assets/icons/outlined-check-circle.svg"
                            : "/assets/icons/outlined-circle.svg"
                        }
                      />
                    </div>
                  ),
                };
              }
              return question;
            }),
          };
        }
        return section;
      });
    });
  };

  const reviewHandler = async (sectionId, questionId, status) => {
    try {
      setReviewData(sectionId, questionId, !status, true);

      let params = {
        id: questionId,
        reviewed_checked: !status,
      };
      const { data } = await ReviewAnswerApi(params);
      if (data?.status) setReviewData(sectionId, questionId, !status, false);
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
      setReviewData(sectionId, questionId, status, false);
    }
  };

  useEffect(() => {
    if (!isModalOpen) {
      form.resetFields();
    }
  }, [isModalOpen]);

  const openInvoiceModal = async () => {
    try {
      setIsModalOpen(true);
      setIsLoadingInvoice(true);
      const { data } = await GetInvoiceListApi();
      if (data?.status) {
        setInvoiceOptions(
          data?.data?.map((item) => {
            return {
              value: item?.id,
              label: `${item?.name} - $${item?.amount}`,
            };
          })
        );
      }
      setIsLoadingInvoice(false);
    } catch (error) {
      setIsLoadingInvoice(false);
    }
  };

  const unsubmitOrganizer = async () => {
    try {
      setIsUnsubmitLoading(true);
      const { data } = await UnsubmitOrganizerApi({ organizer_id: id });
      if (data?.status) {
        toast.success(data?.message);
        setIsUnsubmitOpen(false);
        navigate("/verify_doc");
      }
      setIsUnsubmitLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.message);
      setIsUnsubmitLoading(false);
    }
  };

  return (
    <div className="mb-6">
      <div className="border-2 rounded-xl p-5">
        {isLoading ? (
          <div className="flex justify-center flex-col mt-[20%]">
            <Spin size="large" />
            <p className="primary text-center mt-2">Loading...</p>
          </div>
        ) : (
          <>
            <div className="flex justify-between gap-5 mb-5">
              <div>
                {clientData?.user && (
                  <div className="flex items-center gap-3">
                    <p className="font-semibold text-xl capitalize">
                      {clientData?.user?.name}
                    </p>
                    <p
                      className="text-blue-500 underline cursor-pointer"
                      onClick={() => navigate(`/client/${clientData?.user_id}`)}
                    >
                      View
                    </p>
                  </div>
                )}
              </div>
              <div className="flex items-center gap-5">
                {clientData?.auth_pdf?.url && (
                  <PdfLink text={"Authorization"} data={clientData?.auth_pdf} />
                )}
                {clientData?.gst_pdf?.url && (
                  <PdfLink text={"GST"} data={clientData?.gst_pdf} />
                )}
                <Button
                  type="primary"
                  className="uppercase"
                  onClick={() => setIsUnsubmitOpen(true)}
                >
                  Unsubmit
                </Button>
              </div>
            </div>

            {data?.map((item, index) => (
              <div className="table-radius-0 text-light mb-10">
                <p className="font-semibold text-xl text-primary mb-5">
                  {`Section ${index + 1}:`} {item?.section_name}
                </p>
                <SkeletonTable
                  columns={columns}
                  data={item?.questions}
                  isLoading={isLoading}
                />
              </div>
            ))}
            <Button
              type="primary"
              className="uppercase py-4"
              onClick={openInvoiceModal}
            >
              Complete Review
            </Button>
          </>
        )}
      </div>

      <ModalComponent
        isOpen={isModalOpen}
        setIsOpen={setIsModalOpen}
        title="Invoice"
      >
        {isLoadingInvoice ? (
          <div className="flex justify-center flex-col my-[10%]">
            <Spin size="large" />
            <p className="primary text-center mt-2">Loading...</p>
          </div>
        ) : (
          <Form
            autoComplete="off"
            form={form}
            initialValues={initialValues}
            onFinish={sendInvoiceHandler}
          >
            <Form.Item
              name="invoice_temp_id"
              rules={[{ required: true, message: "Please select invoice type!" }]}
            >
              <Select
                placeholder="Select Invoice"
                options={invoiceOptions}
                size="large"
              />
            </Form.Item>
            <div className="flex justify-center ">
              <LoadableButton
                className="bg-primary text-white uppercase text-base font-semibold w-full py-2 rounded-lg mt-2"
                type="submit"
                lable="Send Invoice"
                loadingLable="Sending Invoice..."
                isLoading={isLoadingSubmit}
              />
            </div>
          </Form>
        )}
      </ModalComponent>

      {/* Unsubmit Organizer */}
      <ConfirmationModal
        isOpen={isUnsubmitOpen}
        setIsOpen={setIsUnsubmitOpen}
        message="Are you sure, want to unsubmit this organizer?"
        onConfirm={unsubmitOrganizer}
        isLoading={isUnsubmitLoading}
        loadingLabel="Loading..."
      />

      {/* Edit Answer */}
      <AnswerModal
        isOpen={isAnswerOpen}
        setIsOpen={setIsAnswerOpen}
        question={selectedQuestion}
        reloadQuestions={getQuestions}
      />

      {/* View Files */}
      <ViewFilesModal
        isOpen={isFilesOpen}
        setIsOpen={setIsFilesOpen}
        question={selectedQuestion}
      />
    </div>
  );
}
